import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { setLenis } from "@/components/landing/motion";
import { Hero } from "@/components/landing/Hero";
import { Objections } from "@/components/landing/Objections";
import { KitMarquee } from "@/components/landing/KitMarquee";
import { Opportunity } from "@/components/landing/Opportunity";
import { IncomeMath } from "@/components/landing/IncomeMath";
import { Bonus } from "@/components/landing/Bonus";
import { Pricing } from "@/components/landing/Pricing";
import { Guarantee, Testimonials } from "@/components/landing/Proof";
import { Faq } from "@/components/landing/Faq";
import { TopBar } from "@/components/landing/TopBar";
import { FinalCta, StickyCta } from "@/components/landing/FinalCta";


export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    setLenis(lenis);
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); setLenis(null); };
  }, []);

  return (
    <main className="bg-paper font-body text-ink antialiased">
      <TopBar />
      <Hero />
      <Objections />
      <KitMarquee />
      <Opportunity />
      <IncomeMath />
      <Bonus />
      <Pricing />
      <Guarantee />
      <Testimonials />
      <Faq />
      <FinalCta />
      <StickyCta />
      <Toaster position="top-center" />
    </main>
  );
}
